import Controller from '@/components/pages/token-transparency/token-transparency-page-controller';
import getStaticProps from '@/components/pages/token-transparency/token-transparency-page-static-props';

export default Controller;
export { getStaticProps };
